import { CategoryDTO } from '@sb-tools/typescript/models/dto/category.dto';
import { DetailedTicketSource } from '@sb-tools/typescript/enums/detailed-ticket-source.enum';
import { Importance } from '@sb-tools/typescript/enums/importance.enum';
import { BaseUserWithRole } from '@sb-tools/typescript/models/base-user-with-role.model';
import { TicketSource } from '@sb-tools/typescript/enums/ticket-source.enum';
import { MessageDTO } from '@sb-tools/typescript/models/dto/message.dto';
import { Sentiment } from '@sb-tools/typescript/enums/sentiment.enum';
import { TicketStatus } from '@sb-tools/typescript/enums/ticket-status.enum';
import { SessionAuthenticationDTO } from '@sb-tools/typescript/models/dto/session-authentication.dto';

export class TicketDTO {
    assignee: BaseUserWithRole;
    assignerId: string;
    badWordsRate: number; // int
    category: CategoryDTO;
    communityId: number;
    detailedSource: DetailedTicketSource;
    firstMessageCreationTime: Date;
    firstMessageCreator: BaseUserWithRole;
    firstMessageCreatorId: string;
    forwardedTo: string[];
    hasAttachments: boolean;
    hasDraft: boolean;
    hasLinkedTickets: boolean;
    hasOriginalMessage: boolean;
    hasSatisfactionEntry: boolean;
    hasStaffAnswer: boolean;
    hasSurvey: boolean;
    id: number;
    importance: Importance;
    initialPageUrl: string;
    isAccessShared: boolean;
    isAdTicket: boolean;
    isAnonymized: boolean;
    isAssigned: boolean;
    isAssignedToBot: boolean;
    isEdited: boolean;
    isExpired: boolean;
    isFirstMessageDeleted: boolean;
    isHidden: boolean;
    isMuted: boolean;
    isReviewNeeded: boolean;
    isSentToBergHansen: boolean;
    isSentToIndigo: boolean;
    isSentToServiceNow: boolean;
    isSentToSupperOffice: boolean;
    isSourceDeprecated: boolean;
    isSpam: boolean;
    lastThreadElementCreationTime: Date;
    latestPageUrl: string;
    latestPageUrlUpdatedAt?: string | null;
    message: MessageDTO;
    noteCount: number; // int
    permalink: string;
    privateReplyTicketId?: number; // long?
    replyCount: number;
    sentiment: Sentiment;
    sessionAuthentication: SessionAuthenticationDTO | null;
    source: TicketSource;
    sourceName: string;
    status: TicketStatus;
    title: string;
}
